/** @jsx jsx */
import React from 'react'
import { jsx } from '@emotion/core'
import { observer } from 'mobx-react'
import AdvImg from '@components/AdvImg'
import { AnalysisProfileCardWrap } from '@views/Matchup/MatchUpDetail/index.style'
import { UserPickSpecialMemberMark } from '@views/Home/UserPick/Components/UserPickSpecialMemberMark'
import classNames from 'classnames'
import { Schema$ContentUserInfo } from '@protocol/user'

interface AnalysisProfileProps {
  userInfo: Schema$ContentUserInfo
  lightMode?: boolean
}

export const AnalysisProfile: React.FC<AnalysisProfileProps> = observer((props)=> {
  const { userInfo, lightMode } = props

  const profileElem = (
    <div className="profile">
      <span className={userInfo.userProfileImg ? 'profile-img custom' : 'profile-img'}>
        {userInfo.isCustomProfileImg ?
          (<AdvImg src={userInfo?.userProfileImg} srcMode={'small'} alt="사진첩 이미지" className="custom-img"/>)
          :
          (<AdvImg src={userInfo?.userProfileImg} srcMode={'small'} alt="스킨" className="zoom-img"/>)
        }
      </span>
      <UserPickSpecialMemberMark
        showSMark={userInfo.hasSpecialMark}
        isSpecialMember={userInfo.isSpecialMember}
        userTitleId={userInfo.userTitleId}
        userTitleEnabled={true}
        medium
        sub2Border
        whiteBgBorder={lightMode}
      />
    </div>
  )

  const profileCardClassName = classNames('', {
    'light-mode': lightMode,
  })

  return (
    <AnalysisProfileCardWrap className={profileCardClassName}>
      {profileElem}
      <p className="user-nick">{userInfo.userNick}</p>
    </AnalysisProfileCardWrap>
  )
})
